import * as React from 'react';
import Step from '../Step';
import { StepProperties, PrivateStepState, SharedStepState } from '../Step';
import ProviderCard from '../../common/ProviderCard';
import { providers } from '../../../utils/constants';
import { Provider } from '../../../models/filespace/provider';
import { EventManager } from '../../../services/EventManager';
import { WebportalEvent } from '../../../services/WebportalEvent';

export interface ProviderSharedStepState extends SharedStepState {
    provider: Provider | null;
    isFilespaceNameAboveProviderLimit: boolean;
}

interface ProviderPrivateStepState extends PrivateStepState {}
interface ProviderStepState extends ProviderPrivateStepState, ProviderSharedStepState {}

export default class ProviderStep extends Step<StepProperties<ProviderSharedStepState>, ProviderStepState, ProviderStepState> {
    constructor(props: any) {
        super(props);

        this.selectProvider = this.selectProvider.bind(this);

        this.state = this.props.savedState;
    }

    protected getSharedStepState(): ProviderStepState {
        return {
            provider: this.state.provider,
            isFilespaceNameAboveProviderLimit: this.state.isFilespaceNameAboveProviderLimit
        };
    }

    componentDidMount() {
        EventManager.fireCustomEvent(WebportalEvent.OrderFlexCards);
    }

    render() {
        const providerCards = providers.map((provider: any) => {
            return (
                <ProviderCard
                    key={provider.providerData.primaryName}
                    provider={provider}
                    isSelected={provider === this.state.provider}
                    onSelectProvider={this.selectProvider}
                />
            );
        });

        return (
            <div className="col-12 col-lg-8 col-xl-8 d-flex align-items-center provider-step">
                <div className="container p-0">
                    <div className="cards-container cards-center cards-small">
                        {providerCards}
                    </div>
                </div>
            </div>
        );
    }

    private selectProvider(provider: Provider) {
        this.setState({ provider: provider }, () => {
            this.completeStep();
        });
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/wizard/components/ProviderStep.tsx